import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import AppWrapper from '../app_wrapper';
import ProductDetailMobile from '../components_mobile/pages/ProductDetail';
import ProductDetailDesktop from '../components_desktop/pages/ProductDetail';
import { apiGet } from '../modules/api';
import { search } from '../helpers/routes';
import metadata from '../helpers/metadataHelper';
import Departments from '../common/models/Departments';
import { ReactPixel } from '../helpers';

class ProductDetailComponent extends Component {
  componentDidMount() {
    ReactPixel.track('ViewContent', this.props.fbPixelData);
  }

  render() {
    return (
      <AppWrapper
        desktopComp={<ProductDetailDesktop {...this.props} />}
        mobileComp={<ProductDetailMobile {...this.props} />}
        metadata={metadata.productDetail}
      />
    );
  }

  static async getInitialProps({ store, req, res }) {
    const { params } = req;
    const { cat_1, cat_3, brand_name, product_id, product_version_id } = params;

    const response = await store.dispatch(
      apiGet(`api/products/${product_id}/${product_version_id}`, req, res, {}, () => {
        const department = cat_1.toLowerCase() === 'unisex' ? 'women' : cat_1.toLowerCase();
        const highestLevelDepartment = Departments.getKidsDepartmentsInternalNames().includes(department)
          ? Departments.getKidsInternalName()
          : department;

        const productCategory = cat_3 || '';
        const brand = brand_name.replace(/-/g, ' ');
        let query;
        if (productCategory) {
          query = `${brand} ${productCategory}`;
        } else {
          query = brand;
        }

        const prefix = req.params && req.params.countryCode ? `/${req.params.countryCode}` : '';
        const pathname = `${prefix}${search(highestLevelDepartment, query)}`;
        res.redirect(301, pathname);
      })
    );

    const product = get(store.getState(), 'api.product');
    req.datadog.increment('consumer_app.product_details');
    const url = req.url || 'none';
    const referrer = req.get('Referrer') || 'none';
    if (isEmpty(product) || product.product_is_active === 'N' || product.isExcluded) {
      req.datadog.increment('consumer_app.product_unavailable', { url, referrer });
      req.datadog.event('Product unavailable requested', url, {}, { referrer });
    }

    if (product && product.images && product.images.length === 0) {
      req.datadog.increment('consumer_app.product_no_images', { url, referrer, product_id, product_version_id });
      req.datadog.event('Product with no images requested', url, {}, { referrer, product_id, product_version_id });
    }

    return {};
  }
}

const mapStateToProps = ({
  api: {
    category_id,
    currencySymbol,
    fbPixelAddCartData,
    fbPixelData,
    freeShipping,
    path,
    product,
    s3BasePath,
    trackingProductData,
    trackingSizeData
  },
  updateOverflowScroll
}) => ({
  categoryId: category_id,
  currencySymbol,
  fbPixelAddCartData,
  fbPixelData,
  freeShipping,
  path,
  product,
  s3BasePath,
  updateOverflowScroll,
  trackingProductData,
  trackingSizeData
});

const ProductDetail = withRouter(connect(mapStateToProps)(ProductDetailComponent));
export default ProductDetail;
